module.exports = __webpack_public_path__ + "static/media/vortex.f1435caf.png";